<div class="page-container">
	<div class="background-wrapper">
		<app-particle-background></app-particle-background>
	</div>

	<div class="content-wrapper">
		<div class="card-wrapper">
			<div class="card-inner">
				<div class="logo-section">
					<div class="image-container">
						<img id="logo" src="icons/logo-vertical.svg" alt="WindowPerfect — Click · Configure · Complete" />
					</div>
					<p class="app-subtitle">Reset your password</p>
				</div>

				@if (state() === 'verifying') {
				<div class="loading-state">
					<mat-spinner diameter="40"></mat-spinner>
					<p>Verifying your reset link...</p>
				</div>
				} @if (state() === 'invalid') {
				<div class="error-state animate-enter">
					<mat-icon class="error-icon">link_off</mat-icon>
					<h2>Link Expired</h2>
					<p>This link is invalid or has expired.</p>
					<p class="hint">Please request a new password reset, then open the newest email we send you.</p>
				</div>
				} @if (state() === 'form') {
				<div class="form-wrapper animate-enter">
					<div class="account-text">
						<span>You are resetting the password for</span>
						<p class="account-email">{{ userEmail() }}</p>
					</div>

					<form [formGroup]="resetForm" (ngSubmit)="onSubmit()" novalidate>
						<mat-form-field appearance="outline" class="input">
							<mat-label>New Password</mat-label>
							<input
								matInput
								[type]="hidePassword() ? 'password' : 'text'"
								formControlName="password"
								autocomplete="new-password"
								autocapitalize="none"
								autocorrect="off"
								spellcheck="false"
								(input)="clearSubmitErrors()"
							/>
							<button mat-icon-button matSuffix type="button" (click)="hidePassword.set(!hidePassword())">
								<mat-icon>{{ hidePassword() ? 'visibility' : 'visibility_off' }}</mat-icon>
							</button>
						</mat-form-field>

						@if (weakPassword()) {
						<p class="inline-error">That password was rejected as too weak. Try a longer password with a less common pattern.</p>
						}

						<div class="requirements-list">
							<div class="req-item" [class.valid]="!hasError('minlength') && passwordControl?.value">
								<mat-icon>check_circle</mat-icon> <span>8+ Characters</span>
							</div>
							<div class="req-item" [class.valid]="!hasError('hasNumber') && passwordControl?.value"><mat-icon>check_circle</mat-icon> <span>Number</span></div>
							<div class="req-item" [class.valid]="!hasError('hasCapitalCase') && passwordControl?.value">
								<mat-icon>check_circle</mat-icon> <span>Uppercase</span>
							</div>
							<div class="req-item" [class.valid]="!hasError('hasSmallCase') && passwordControl?.value"><mat-icon>check_circle</mat-icon> <span>Lowercase</span></div>
							<div class="req-item" [class.valid]="!hasError('hasSpecialCharacters') && passwordControl?.value">
								<mat-icon>check_circle</mat-icon> <span>Symbol</span>
							</div>
						</div>

						<mat-form-field appearance="outline" class="input">
							<mat-label>Confirm New Password</mat-label>
							<input
								matInput
								[type]="hideConfirmPassword() ? 'password' : 'text'"
								formControlName="confirmPassword"
								autocomplete="new-password"
								autocapitalize="none"
								autocorrect="off"
								spellcheck="false"
							/>
							<button mat-icon-button matSuffix type="button" (click)="hideConfirmPassword.set(!hideConfirmPassword())">
								<mat-icon>{{ hideConfirmPassword() ? 'visibility' : 'visibility_off' }}</mat-icon>
							</button>
						</mat-form-field>

						@if (resetForm.hasError('notMatching') && confirmControl?.touched) {
						<p class="inline-error">Passwords do not match</p>
						} @if (submitError()) {
						<p class="inline-error">{{ submitError() }}</p>
						}

						<div class="actions">
							<button mat-raised-button color="primary" class="submit-btn" type="submit" [disabled]="resetForm.invalid || submitting()">
								<div class="label">
									@if (submitting()) {
									<mat-spinner diameter="20"></mat-spinner>
									} Update Password
								</div>
							</button>
						</div>
					</form>
				</div>
				} @if (state() === 'success') {
				<div class="success-state animate-enter">
					<mat-icon class="success-icon">check_circle</mat-icon>
					<h2>Password updated</h2>
					<p>You can now sign in with your new password.</p>
				</div>
				}
			</div>
		</div>
	</div>
</div>
